import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Text } from "@similarweb/ui-components/foundations";

import Alert from "../../images/alert.svg";
import { ImageFailed, TextFailed } from "../../SwitchPackageStage.styled";

export const StageFailureIcon = () => (
    <ImageFailed
        src={Alert}
        alt="alert"
    />
);

interface IStageFailureDescriptionProps {
    onContactClick: () => void;
}

export const StageFailureDescription = ({ onContactClick }: IStageFailureDescriptionProps) => {
    const { translate } = useTranslate();
    return (
        <>
            <Text
                fontVariant="body1"
                color={colorsPalettes.carbon[300]}
                dangerouslySetInnerHTML={{
                    __html: translate("subscription.info.nt.change.plan.failure.description"),
                }}
            />
            <TextFailed
                fontVariant="body1"
                color={colorsPalettes.blue[400]}
                onClick={onContactClick}
                data-automation="package-switcher-stage-failure-contact"
            >
                {translate("subscription.info.nt.change.plan.failure.description.contact")}
            </TextFailed>
        </>
    );
};
